import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";
import { SwiperOptions } from "swiper/types";
import "swiper/css";
import "swiper/css/effect-fade";

Swiper.use([Autoplay, EffectFade]);

const sliderOption: SwiperOptions = {
  slidesPerView: 2,
  loop: true,
  autoplay: {
    delay: 3000,
  },
  effect: "fade",
  speed: 2000,
};

// スライダー
const swiper = new Swiper(".home-slider", sliderOption);
